import { fetchApi } from '@/config/axiosSetting';
import { PatchOwnerInitialInfoQueryParamsType } from '@/modules/adjusterReportModules/IncidentParticipants/queries/culprit/patchOwnerInitialInfo/patchOwnerInitialInfoQuery.type';

export const patchOwnerInitialInfoFunction = (
  params: PatchOwnerInitialInfoQueryParamsType,
) => {
  return fetchApi.patch(
    `property/reports/${params?.id}/accident_users/culprit/user_information/owner/personal_information/`,
    params?.data,
    {
      params: {
        id: params?.id,
      },
    },
  );
};
